<template>
  <div class="login__box">
    <div class="login__box__welcome">
     <!-- <div class="login__box__welcome__top">Adgame</div>
      <div class="login__box__welcome__bottom">Password reset</div>-->
    </div>

    <div class="login__box__input-description">Your email</div>
    <input
      v-model="form.email"
      type="text"
      class="login__box__input-email"
      placeholder="email"
    />

    <div>
      <div class="login__box__register">
        <button @click="backToLogin()">Back to login</button>
      </div>
    </div>

    <div class="login__box__login" @click="submitForm">
      <button class="button">Reset</button>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "ForgotPasswordBox",
  data() {
    return {
      form: {
        email: "",
      },
    };
  },
  methods: {
    backToLogin() {
      this.$emit("backToLogin");
    },

    ...mapActions({ forgotPassword: "forgotPassword" }),

    checkEmptyForm() {
      if (this.form.email == "") {
        this.$toast.error(
          this.$t("messages.user-account.forgot-password-empty-field")
        );
        return false;
      }
      return true;
    },

    async submitForm() {
      if (!this.checkEmptyForm()) return false;

      await this.$store.dispatch("toggleLoader", true);
      try {
        await this.forgotPassword(this.form.email);
        this.$toast.success(
          this.$t("messages.user-account.forgot-password-success")
        );
        this.backToLogin();
      } catch (e) {
        window.console.log(e.response.data.msg);
        var error = e
        if(e.response.data.msg == "user-mng.reset-pwd.nonexistent-email"){
          error = "Wrong username or email"
        }
        this.$toast.error(
          this.$t("messages.user-account.forgot-password-failed", { msg: error })
        );
      }
      await this.$store.dispatch("toggleLoader", false);
    },
  },
};
</script>

<style>
</style>
